export default "__VITE_ASSET__CS9TpFqa__"